import { useAppStore } from "@/stores";
import { IntegrationCard } from "./components/card";
import { integrations } from "@/constants/integrations";
import useSWR from "swr";
import { TableType, get, getAll } from "@/lib/supabase";
import { Loader } from "@/components/Loader";
import { LoadingError } from "@/components/LoadingError";

export function IntegrationsPage() {
  const currentUser = useAppStore((state) => state.currentUser);
  const {
    data: company,
    error: companyError,
    isLoading: companyIsLoading,
  } = useSWR(
    [
      "companies" as TableType,
      currentUser ? currentUser?.company_id?.toString() : null,
    ],
    ([table, companyId]) => get(table, companyId)
  );
  const {
    data: tokens,
    error: tokensError,
    isLoading: tokensIsLoading,
    mutate,
  } = useSWR(
    [
      "tokens" as TableType,
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([table, companyId]) => getAll(table, companyId)
  );

  if (companyIsLoading || tokensIsLoading || !company || !tokens) return <Loader />;
  if (companyError || tokensError) return <LoadingError />;

  return (
    <>
      <div className="flex items-center justify-between space-y-2 pt-3 pb-4">
        <h1>Integrations</h1>
      </div>
      <div className="grid auto-rows-max items-start gap-4 md:gap-8 lg:col-span-3">
        <div className="hidden items-start justify-center gap-6 rounded-lg p-0 md:grid lg:grid-cols-2 xl:grid-cols-3">
          {integrations.map((integration) => (
            <IntegrationCard
              key={integration.id}
              integration={integration}
              tokens={tokens}
              company={company}
              mutate={mutate}
            />
          ))}
        </div>
      </div>
    </>
  );
}
